// Types
import { tooltipPlacement } from '@/types/tooltip';

const PLACEMENT: Record<string, tooltipPlacement> = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

const LEFT_EDGE_THRESHOLD = 150;

/**
 * Calculate smart tooltip placement based on element position
 * If element is near the left edge, switch top/bottom placement to right
 */
export const calculateSmartPlace = (element: Element, desiredPlace: tooltipPlacement): tooltipPlacement => {
  const rect = element.getBoundingClientRect();
  const isNearLeftEdge = rect.left < LEFT_EDGE_THRESHOLD;

  if (isNearLeftEdge && (desiredPlace === PLACEMENT.TOP || desiredPlace === PLACEMENT.BOTTOM)) {
    return PLACEMENT.RIGHT;
  }
  return desiredPlace;
};

export { PLACEMENT };
